const services = [
  {
    icon: 'ri-google-line',
    title: 'Google Ads Setup & Management',
    desc: 'We build and manage campaigns that target high-intent buyers actively searching for your services right now.',
  },
  {
    icon: 'ri-layout-line',
    title: 'High-Converting Landing Pages',
    desc: 'Pages engineered to turn clicks into calls. Every element is designed with one goal: get you more customers.',
  },
  {
    icon: 'ri-phone-line',
    title: 'Call + Lead Tracking',
    desc: 'Know exactly where every lead comes from. Full visibility into what\'s working and what\'s not.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Ongoing Optimization',
    desc: 'We continuously test and improve your campaigns so your cost per lead keeps going down over time.',
  },
];

const SolutionSection = () => (
  <section id="solution" className="bg-white py-24 md:py-32">
    <div className="max-w-6xl mx-auto px-6 md:px-10">
      <div className="text-center mb-16">
        <span className="text-orange-500 text-xs font-bold uppercase tracking-widest">The Solution</span>
        <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mt-3 leading-tight">
          A Direct Customer Acquisition System
        </h2>
        <p className="text-gray-500 text-lg mt-4 max-w-2xl mx-auto">
          We combine Google Ads and conversion-focused landing pages into one seamless system that brings customers to you — on demand.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {services.map((s) => (
          <div
            key={s.title}
            className="group border border-gray-100 hover:border-orange-200 rounded-2xl p-8 transition-all duration-300 hover:shadow-lg bg-white"
          >
            <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-orange-50 mb-6 group-hover:bg-orange-100 transition-colors">
              <i className={`${s.icon} text-orange-500 text-2xl`} />
            </div>
            <h3 className="text-gray-900 font-bold text-lg mb-3 leading-snug">{s.title}</h3>
            <p className="text-gray-500 text-sm leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default SolutionSection;
